export default [
  {
    original: require("../images/gallery/TK_karneval/2010_Karneval_(2).jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2010_Karneval_(2).jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/2010_Karneval_in_Baerbroich.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2010_Karneval_in_Baerbroich.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/2010_Karneval.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2010_Karneval.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/2011_Karneval_in_Engelskirchen.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2011_Karneval_in_Engelskirchen.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/2012_Karneval_im_Dorfhaeuschen.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2012_Karneval_im_Dorfhaeuschen.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/2012_Karneval_in_Baerbroich.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/2012_Karneval_in_Baerbroich.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/big_R1_(10).jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/big_R1_(10).jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/big_R1_(16).jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/big_R1_(16).jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01839.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01839.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01841.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01841.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01845.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01845.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01846.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01846.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01848.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01848.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01850.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01850.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01856.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01856.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC01890.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC01890.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC06506.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC06506.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/DSC06507.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/DSC06507.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/IMG_5049.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/IMG_5049.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/IMG_5058.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/IMG_5058.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/IMG_5067.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/IMG_5067.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/Nach_dem_Rosenmontagszug_bei_Edith.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/Nach_dem_Rosenmontagszug_bei_Edith.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0010.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0010.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0037.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0037.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0040.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0040.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0043.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0043.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0047.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0047.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0048.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0048.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0050.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0050.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0074.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0074.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0087.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0087.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0090.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0090.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0091.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0091.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0094.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0094.jpg")
  },
  {
    original: require("../images/gallery/TK_karneval/PICT0113.jpg"),
    thumbnail: require("../images/gallery/TK_karneval/thumb/PICT0113.jpg")
  }
];



// WEBPACK FOOTER //
// ./src/components/gallerylists/imageskarneval.js